import { Component, input } from '@angular/core';

@Component({
  selector: 'eiq-header-main-title',
  templateUrl: './header-main-title.component.html',
  styleUrls: ['./header-main-title.component.scss']
})
export class HeaderMainTitleComponent {
  title = input<string>();
  subtitle = input<string>();
}
